import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { cn } from "../lib/cn";

export function UserMenu() {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  if (!user) return null;

  const initials = user.email.slice(0, 2).toUpperCase();

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-600 text-sm font-semibold text-white hover:bg-brand-700"
        title={user.email}
      >
        {initials}
      </button>
      {isOpen ? (
        <div
          role="menu"
          className={cn(
            "absolute right-0 mt-2 w-56 rounded-md border border-slate-200 bg-white p-1 shadow-lg",
            "dark:border-slate-700 dark:bg-slate-800",
          )}
        >
          <div className="border-b border-slate-100 px-3 py-2 text-xs text-slate-500 dark:border-slate-700 dark:text-slate-400">
            Signed in as
            <div className="font-medium text-slate-900 dark:text-slate-100">{user.email}</div>
          </div>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setIsOpen(false);
              void logout();
            }}
            className="block w-full rounded px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-700"
          >
            Sign out
          </button>
        </div>
      ) : null}
    </div>
  );
}
